import { useContext, useEffect } from "react";
import { Link, useNavigate } from "react-router";
import { Context } from "../../../models/context";
import Help from "../../../components/help/Help";
import "./stats.css";

const STAT_LINKS = [
  { label: "Users", path: "/stats/stats-users" },
  { label: "Groups", path: "/stats/stats-groups" },
  { label: "Apps", path: "/stats/stats-apps" },
  { label: "Projects", path: "/stats/stats-projects" },
];

export default function Stats() {
  const context = useContext(Context);
  const navigate = useNavigate();

  useEffect(() => {
    if (!context.user) navigate("/login");
  }, [context.user, navigate]);

  return (
    <div id="stats-main">
      <div id="stats-wrapper" className="container">
        <div className="help-title">
          <h1>Stats Dashboard</h1>
          <Help title="Stats Dashboard" color="var(--green-medium)" className="help-button">
            <p>As an admin, this is where you can view the stats summary for the RLL apps, groups, and users.</p>
          </Help>
        </div>
        <div id="stats-links">
          {STAT_LINKS.map(({ label, path }, i) => (
            <Link to={path} key={label}>
              <div className="link container" id={i === 0 ? "first-link" : undefined}>
                {label}
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}